import { Box, Icon } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import useOverlimitEmployeesChecker from 'modules/employees/components/OverlimitEmployees/useOverlimitEmployeesChecker'

const OverlimitEmployeesFootNote = () => {
  const { isOverlimit, currentSeats, limitEmployeesCurrentPlan } = useOverlimitEmployeesChecker()
  if (!isOverlimit) return null

  return (
    <Box flexDirection="row" alignItems="flexStart" gap="s8">
      <Box>
        <Icon.Medium icon="upgrade-plan" color="champagne1000" />
      </Box>
      {i18n.tView('overlimit_employees.foot_note.message', {
        currentSeats: <span>{currentSeats}</span>,
        limitEmployeesCurrentPlan: <span>{limitEmployeesCurrentPlan}</span>,
      })}
    </Box>
  )
}

export default observer(OverlimitEmployeesFootNote)
